const MANAGED_PACK_THREADS_KEY = "managed-pack-threads";

export const managedPackThreadsKey = (
  businessId: string | null,
  periodStart: string | null,
) => [MANAGED_PACK_THREADS_KEY, businessId, periodStart] as const;

export const managedPackThreadKey = (
  businessId: string | null,
  periodStart: string | null,
  threadId: string | null,
) =>
  [
    MANAGED_PACK_THREADS_KEY,
    businessId,
    periodStart,
    "detail",
    threadId,
  ] as const;

export const managedPackStartOptionsKey = (
  businessId: string | null,
  periodStart: string | null,
) =>
  [MANAGED_PACK_THREADS_KEY, businessId, periodStart, "start-options"] as const;

export const path = (businessId: string, periodStart: string) =>
  `/businesses/${businessId}/pay_periods/${periodStart}/statement_threads`;
